import { createContext } from "react";
export const PreviewContext = /*#__PURE__*/createContext({});